import {FilterCriterionCheckbox} from './filter-criterion-input';
import {QueryLangFilterCriterion} from './query-lang-filter-criterion';

export class QueryLangFilterCriterionCheckbox extends QueryLangFilterCriterion implements FilterCriterionCheckbox {
    public name: string;
    public override query: boolean;
}
